<div class="w-full mx-auto rounded-lg max-h-[90vh] flex flex-col">
  <div class="py-2 px-4 flex-shrink-0">
    <h3 class="titre3">{{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.EDIT_ORGANISATION' | translate }}</h3>
  </div>

  <div class="flex-1 overflow-y-auto p-4 min-h-0">
    @if (isLoading) {
      <mat-spinner class="mx-auto" color="accent"></mat-spinner>
    }
    @if (!isLoading && organisation) {
      <div>
        <label class="block text-sm font-medium mb-4">
          {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.NAME' | translate }} : {{ organisation.nom }}
        </label>
        <div class="mb-4 flex items-center">
          <input type="checkbox" id="aUtilisateursFictifs" [(ngModel)]="aUtilisateursFictifs"
            class="form-checkbox h-5 w-5 rounded mr-2 focus:outline-none focus:ring-0">
            <label for="aUtilisateursFictifs" class="text-sm font-medium">
              {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.A_UTILISATEURS_FICTIFS' | translate }}
            </label>
          </div>
          <div class="mb-4 flex items-center">
            <input type="checkbox" id="aAccesDiffusion" [(ngModel)]="aAccesDiffusion"
              class="form-checkbox h-5 w-5 rounded mr-2 focus:outline-none focus:ring-0">
              <label for="aAccesDiffusion" class="text-sm font-medium">
                {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.A_ACCES_DIFFUSION' | translate }}
              </label>
            </div>
            <div class="mb-4 flex items-center">
              <input type="checkbox" id="aAccesIndex" [(ngModel)]="aAccesIndex"
                class="form-checkbox h-5 w-5 rounded mr-2 focus:outline-none focus:ring-0">
                <label for="aAccesIndex" class="text-sm font-medium">
                  {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.A_ACCES_INDEX' | translate }}
                </label>
              </div>
              <div class="mb-4 flex items-center">
                <input type="checkbox" id="aTenantSSO" [(ngModel)]="aTenantSSO"
                  class="form-checkbox h-5 w-5 rounded mr-2 focus:outline-none focus:ring-0">
                  <label for="aTenantSSO" class="text-sm font-medium">
                    {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.A_TENANT_SSO' | translate }}
                  </label>
                </div>
              </div>
            }
          </div>

          <div class="py-2 px-4 border-t border-gray-300 dark:border-gray-600 flex-shrink-0 flex justify-end">
            <button (click)="onCancel()" type="button" class="btn-secondary-novo">
              {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.ANNULER' | translate }}
            </button>
            <button [disabled]="isSaving" (click)="onSave()" type="submit"
              class="btn-primary-novo disabled:opacity-50 disabled:cursor-not-allowed">
              @if (!isSaving) {
                <span>{{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.SAUVEGARDER' | translate }}</span>
              }
              @if (isSaving) {
                <mat-spinner [diameter]="24" [color]="'accent'"></mat-spinner>
              }
            </button>
          </div>
        </div>
